import React, { useContext, useEffect, useMemo, useState } from 'react';
import { createOptionalContext } from '../../../utils/create-optional-context.js';
import { LegendsContext } from '../../legends/legends-context.js';
const [CardContainerContext, CardContainerContextConsumer, CardContainerContextProvider, useCardContainer,] = createOptionalContext('CardContainerContext');
function cardContainerError(message) {
    return new Error(`[Card Container]: ${message}`);
}
function CardContainerProvider(props) {
    const [hasBody, setHasBody] = useState(false);
    const [hasHeader, setHasHeader] = useState(false);
    const legendsContext = useContext(LegendsContext);
    useEffect(() => {
        if (!legendsContext) {
            return;
        }
        for (const item of props.superscription.items ?? []) {
            legendsContext.addItem(item);
        }
        return () => {
            for (const item of props.superscription.items ?? []) {
                legendsContext.removeItem(item.value);
            }
        };
    }, [props.superscription]);
    const registerBody = () => {
        setHasBody(prevHasBody => {
            if (prevHasBody) {
                throw cardContainerError('Body already registered');
            }
            return true;
        });
        return () => {
            setHasBody(false);
        };
    };
    const registerHeader = () => {
        setHasHeader(prevHasHeader => {
            if (prevHasHeader) {
                throw cardContainerError('Header already registered');
            }
            return true;
        });
        return () => {
            setHasHeader(false);
        };
    };
    const context = useMemo(() => ({
        hasBody,
        hasHeader,
        registerBody,
        registerHeader,
        superscription: props.superscription,
    }), [hasBody, hasHeader, props.superscription]);
    return (React.createElement(CardContainerContextProvider, { value: context }, props.children));
}
export { CardContainerContext, CardContainerContextConsumer, CardContainerProvider, useCardContainer, };
//# sourceMappingURL=card-container-context.js.map